import { ref, computed, readonly } from 'vue';
import { useModals } from '@/composables/useModals';

export enum InteractiveTourTrianglePosition {
  TopLeft,
  TopCenter,
  TopRight,
  RightTop,
  RightCenter,
  RightBottom,
  BottomRight,
  BottomCenter,
  BottomLeft,
  LeftBottom,
  LeftCenter,
  LeftTop
};

const currentTourPageIndex = ref(-1);
const registeredPages = ref<number[]>([]);
const currentTourPage = computed<number | null>(() => {
  return registeredPages.value[currentTourPageIndex.value] ?? null;
});
const isTourActive = computed<boolean>(() => {
  return typeof currentTourPage.value === 'number';
});

function startInteractiveTour() {
  currentTourPageIndex.value = 0;
}

function endInteractiveTour() {
  currentTourPageIndex.value = -1;
}

function nextTourPage() {
  const { launchEndInteractiveTourModal } = useModals();

  if (!isTourActive.value) {
    return;
  }

  currentTourPageIndex.value++;

  if (currentTourPageIndex.value > registeredPages.value.length - 1) {
    launchEndInteractiveTourModal();
    endInteractiveTour();
  }
}

function previousTourPage() {
  if (!isTourActive.value || currentTourPageIndex.value == 0)
    return;
  currentTourPageIndex.value--;
}

function goToPage(pageNumber: number) {
  currentTourPageIndex.value = pageNumber;
}

function registerTourPage(pageNumber: number) {
  if (registeredPages.value.includes(pageNumber)) {
    window.sc3WorkbenchLogger.error('Attempted to register an interactive tour page number that has already been registered.');
    return;
  }
  registeredPages.value.push(pageNumber);
  registeredPages.value.sort((a, b) => a - b);
}

export function useInteractiveTour() {
  return {
    currentTourPage: currentTourPage,
    isTourActive,
    currentTourPageIndex: readonly(currentTourPageIndex),
    startInteractiveTour,
    endInteractiveTour,
    nextTourPage,
    previousTourPage,
    goToPage,
    registerTourPage
  };
}